import api from '@/api';

export default {
  namespaced: true,
  state: {
    locations: [],
    error: {},
  },
  getters: {},
  mutations: {
    /**
     * Update list of all locations
     * @param {*} state
     * @param {*} payload
     */
    SET_LOCATIONS(state, payload) {
      state.locations = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
  },
  actions: {
    /**
     * Retrieve locations from api
     * @param {*} param0
     */

    list({ commit }, params) {
      let endpoint = '/schedule/locations';

      if (params && params.flat) {
        endpoint = `${endpoint}/flat`;
      }
      return new Promise((resolve, reject) => {
        api()
          .get(endpoint)
          .then((resp) => {
            commit('SET_LOCATIONS', resp.data.data.location);
            resolve(resp.data);
          })
          .catch((err) => {
            // dependant on the message, we need to either return an error response
            // TODO: Should we still return something?
            if (err.response.status !== 404) {
              commit('SET_ERROR', { ...err });
              reject({ ...err });
            }
          });
      });
    },

    add({ dispatch }, location) {
      return new Promise((resolve, reject) => {
        api()
          .post('/schedule/location', { location: { name: location } })
          .then((resp) => {
            dispatch('list');
            resolve(resp.data.data.location[0]);
          })
          .catch((err) => {
            if (err.response.status !== 404) {
              commit('SET_ERROR', { ...err });
              reject({ ...err });
            }
          });
      });
    },
  },
};
